export const translationHashes = {
  "de-DE": "0f9c3790",
  "en-CA": "93d3b919",
  "en-GB": "028efd84",
  "en-US": "a255f3e3",
  "es-ES": "a89a75e6",
  "es-US": "add6359a",
  "formattings": "3b5d04b6",
  "fr-CA": "9f2b784f",
  "nl-NL": "7d69fc74",
  "sv-SE": "5787cc5e"
} as {[lang: string]: string};